import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_123: FaireProductEntity = {
  token: "legacy_prod_abbott-123",
  type: "product",
  name: "Beehive Honey Pot W Lid",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/e91067da78e56175c4ba096ab0bbc63f976ae79b87b75325e0b2a89b8b980a57.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
